import { useContext, useState } from 'react';
import Button from '@mui/material/Button';
import { Context } from '../AuthContext';

const UpgradeButton = ({ text = 'Upgrade to Full Access', sx, ...rest }) => {
  const { user } = useContext(Context);
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const token = await user.getIdToken();
      const response = await fetch(
        process.env.REACT_APP_FLASK_WEBSERVER + 'subscription_details',
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const res = await response.json();
      const hasHadSubscription = Boolean(res?.data?.stripe_customer_id);

      const base = hasHadSubscription
        ? process.env.REACT_APP_STRIPE_CREATOR_RESUBSCRIBE
        : process.env.REACT_APP_STRIPE_CREATOR_PAID_SUBSCRIPTION;
      const url = user?.email ? `${base}?locked_prefilled_email=${user.email}` : base;
      window.location.href = url;
    } catch (error) {
      console.error('Failed to determine upgrade target', error);
      const base = process.env.REACT_APP_STRIPE_CREATOR_PAID_SUBSCRIPTION;
      const url = user?.email ? `${base}?locked_prefilled_email=${user.email}` : base;
      window.location.href = url;
    }
  };

  return (
    <Button
      variant="contained"
      disableRipple
      onClick={handleClick}
      disabled={loading}
      sx={{
        textTransform: 'none',
        boxShadow: 'none',
        '&:hover': { boxShadow: 'none' },
        ...sx,
      }}
      {...rest}
    >
      {text}
    </Button>
  );
};

export default UpgradeButton;
